"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomService = void 0;
var axios_1 = __importDefault(require("axios"));
var browser_info_1 = require("../shared/browser-info");
var GET_HISTORY_UPLOAD_ROUTE = '/api/rooms/{roomId}/upload'; //Deprecated. Please use 'CREATE_URL_FOR_UPLOAD_ROUTE' instead
var CREATE_URL_FOR_UPLOAD_ROUTE = '/api/rooms/{roomId}/createUrlForUpload';
var INCREMENT_COUNT_ROUTE = '/api/rooms/counter/{roomId}';
var ASK_FOR_ASSISTANCE_ROUTE = '/api/rooms/{roomId}/askForAssistance';
var ASKED_FOR_ASSISTANCE_ROUTE = '/api/rooms/{roomId}/askedForAssistance';
var GET_EVE_SETTINGS_ROUTE = '/api/rooms/{roomId}/eveSettings';
var SENT_URL_ROUTE = '/api/rooms/{roomId}/sentUrl';
var END_ROOM_ROUTE = '/api/rooms/end/{roomId}';
var EVE_REPORTED_FIELD = '/api/rooms/{roomId}/setEveReportedField';
var REPORTED_FIELD = '/api/rooms/{roomId}/setReportedField';
var DEVICE_INFO = 'api/rooms/deviceInfo/{roomId}';
var ID_BY_GUID = '/api/shorturl/{guid}/id';
var ROOM_STATUS_BY_PENDING_ROOM = '/api/rooms/getRoomStatusByPendingRoom/{pendingRoomGuid}';
var RoomService = /** @class */ (function () {
    function RoomService(url) {
        this._http = axios_1.default.create({
            baseURL: url,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    RoomService.prototype.getHistoryUploadUrl = function (roomId, payload) {
        return __awaiter(this, void 0, void 0, function () {
            var fileName, fileType, fileSize, isTemp, isAuto, url, response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fileName = payload.fileName, fileType = payload.fileType, fileSize = payload.fileSize, isTemp = payload.isTemp, isAuto = payload.isAuto;
                        url = GET_HISTORY_UPLOAD_ROUTE.replace('{roomId}', roomId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.post(url, {
                                fileName: fileName,
                                fileType: fileType,
                                fileSize: fileSize,
                                isTemp: isTemp,
                                isAuto: isAuto
                            })];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        throw new Error('Error get upload url');
                    case 4: return [2 /*return*/, response.data];
                }
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    RoomService.prototype.createUrlForUpload = function (roomId, payload) {
        return __awaiter(this, void 0, void 0, function () {
            var fileName, fileType, fileSize, isTemp, isAuto, url, response, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fileName = payload.fileName, fileType = payload.fileType, fileSize = payload.fileSize, isTemp = payload.isTemp, isAuto = payload.isAuto;
                        url = CREATE_URL_FOR_UPLOAD_ROUTE.replace('{roomId}', roomId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.post(url, {
                                fileName: fileName,
                                fileType: fileType,
                                fileSize: fileSize,
                                isTemp: isTemp,
                                isAuto: isAuto
                            })];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        throw new Error('Error get upload url');
                    case 4: return [2 /*return*/, response.data];
                }
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    RoomService.prototype.incrementCount = function (roomId, payload) {
        return __awaiter(this, void 0, void 0, function () {
            var type, message, url, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        type = payload.type, message = payload.message;
                        url = INCREMENT_COUNT_ROUTE.replace('{roomId}', roomId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.put(url, {
                                type: type,
                                message: message
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_3 = _a.sent();
                        throw new Error('Error increment count');
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RoomService.prototype.setEveReportedField = function (roomId, event) {
        return __awaiter(this, void 0, void 0, function () {
            var url, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = EVE_REPORTED_FIELD.replace('{roomId}', roomId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.put(url, {
                                event: event
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_4 = _a.sent();
                        throw new Error('Error in set eve reported field');
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RoomService.prototype.setReportedField = function (roomId, event) {
        return __awaiter(this, void 0, void 0, function () {
            var url, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = REPORTED_FIELD.replace('{roomId}', roomId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.put(url, {
                                event: event
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_5 = _a.sent();
                        throw new Error('Error in set reported field');
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RoomService.prototype.setDeviceInfo = function (roomId, clientType, clientUsingFs, isNative) {
        return __awaiter(this, void 0, void 0, function () {
            var url, err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = DEVICE_INFO.replace('{roomId}', roomId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.put(url, {
                                info: browser_info_1.getBrowserInfo(),
                                isNative: isNative,
                                clientType: clientType,
                                clientUsingFs: clientUsingFs
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_6 = _a.sent();
                        throw new Error('Error in set device info');
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RoomService.prototype.endRoom = function (roomId, payload) {
        return __awaiter(this, void 0, void 0, function () {
            var closedBy, reasonForClosing, url, err_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        closedBy = payload.closedBy, reasonForClosing = payload.reasonForClosing;
                        url = END_ROOM_ROUTE.replace('{roomId}', roomId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.put(url, {
                                closedBy: closedBy,
                                reasonForClosing: reasonForClosing
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_7 = _a.sent();
                        throw new Error('Error in End room');
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RoomService.prototype.askForAssistance = function (roomId) {
        return __awaiter(this, void 0, void 0, function () {
            var url, err_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = ASK_FOR_ASSISTANCE_ROUTE.replace('{roomId}', roomId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.post(url)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_8 = _a.sent();
                        throw new Error('Error askForAssistance');
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RoomService.prototype.askedForAssistance = function (roomId) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, err_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = ASKED_FOR_ASSISTANCE_ROUTE.replace('{roomId}', roomId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.get(url)];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_9 = _a.sent();
                        throw new Error('Error askForAssistance');
                    case 4:
                        if (response && response.data) {
                            return [2 /*return*/, {
                                    clientAskedForAssistance: response.data.clientAskedForAssistance,
                                    isAgentConnected: response.data.fieldsForReports.dashboardConnected
                                }];
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    };
    RoomService.prototype.getSentUrl = function (roomId) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, err_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SENT_URL_ROUTE.replace('{roomId}', roomId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.get(url)];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_10 = _a.sent();
                        throw new Error('Error get sent url');
                    case 4: return [2 /*return*/, response.data];
                }
            });
        });
    };
    RoomService.prototype.getEveSettings = function (roomId) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, err_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = GET_EVE_SETTINGS_ROUTE.replace('{roomId}', roomId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.get(url)];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_11 = _a.sent();
                        throw new Error('Error getEveSettings');
                    case 4: return [2 /*return*/, response.data];
                }
            });
        });
    };
    RoomService.prototype.roomIdByGuid = function (guid) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, err_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = ID_BY_GUID.replace('{guid}', guid);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.get(url)];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_12 = _a.sent();
                        throw new Error('Error get ID by guid ' + guid);
                    case 4: return [2 /*return*/, response.data && response.data.roomId];
                }
            });
        });
    };
    RoomService.prototype.roomStatusByPendingRoom = function (pendingRoomGuid) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, err_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = ROOM_STATUS_BY_PENDING_ROOM.replace('{pendingRoomGuid}', pendingRoomGuid);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.get(url)];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_13 = _a.sent();
                        throw new Error('Error getting room by pending room guid ' + pendingRoomGuid);
                    case 4: return [2 /*return*/, response.data];
                }
            });
        });
    };
    return RoomService;
}());
exports.RoomService = RoomService;

//# sourceMappingURL=RoomService.js.map
